import type { FC, PropsWithChildren } from 'react';

type HiddenLayoutProps = PropsWithChildren;

export const HiddenLayout: FC<HiddenLayoutProps> = ({ children }) => {
  return (
    <div className="bg-neutral-1 flex w-screen flex-col overflow-hidden">
      {children}
    </div>
  );
};
